import { FC, useEffect } from 'react'
import { KTIcon } from '../../../../../../_metronic/helpers'
import { useAuth } from '../../../../auth'


type props = {
  title: string,
  action: {
    excelModal: boolean,
    setExcelModal: React.Dispatch<React.SetStateAction<boolean>>
  }
}
const InvoiceExcelModalHeader: FC<props> = ({ title, action }) => {
  const { currentUser } = useAuth()
  const currentCompany = currentUser?.cpl?.find(x => x.id == currentUser.cpi)?.nm

  useEffect(() => {
  }, [title])

  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <div>
        <h2 className='fw-bolder text-primary'>{title}
          <span className='ms-2 fs-6 text-gray-400'>
            <span className='fw-bolder'>({currentCompany})</span>
          </span>
        </h2>
      </div>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        data-kt-invoices-modal-action='close'
        onClick={() => action.setExcelModal(false)}
        style={{ cursor: 'pointer' }}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export { InvoiceExcelModalHeader }
